import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  redirectFrom: '',
  userType: '',
  selectedpg: {},
  staffdetails: {},
  isLoading: false
};

const CommonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setRedirectFrom: (state, action) => {
      state.redirectFrom = action.payload;
    },
    setLoader: (state, action) => {
      state.isLoading = action.payload;
    },
    setpg: (state, action) => {
      state.selectedpg = action.payload;
    },
    setManager: (state, action) => {
      state.staffdetails = action.payload;
    },
    clearManagerData: (state) => {
      state.staffdetails = {};
    }
  },
});

export const { setUserType, setRedirectFrom, setLoader, setpg, setManager,clearManagerData } = CommonSlice.actions;
export default CommonSlice.reducer;

